import moment from "moment"

const INITIAL_STATE = {
  caixa: [],
  transacoes: [],
  dataHoje: new Date(),
  dadosFiltro: {
    filtroDataDe: new Date(),
    filtroDataAte: new Date(),
    clear: false
  },
  totalPagamento: 0,
  totalRecebimento: 0,
  totalPagamento: 0,
  totalEntrada: 0,
  totalResultado: 0,
  totalSaida: 0,
  totalSaldo: 0,
  grafico: {
    options: {
      chart: {
        id: 'apexchart-example'
      },
      xaxis: {
        categories: [],
        labels: {
          show: true,
          rotate: -45,
          rotateAlways: false,
          hideOverlappingLabels: true,
          showDuplicates: false,
          trim: false,
          minHeight: undefined,
          maxHeight: 120
        }
      }
    },
    series: [
{
      name: 'series-1',
      data: []
    }
],
    stroke: {
      curve: 'straight'
    }
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CAIXA_FLUXO_FETCH': {
      let caixaCopy = [...state.caixa]
      caixaCopy = action.payload

      let graficoCopy = { ...state.grafico }
      graficoCopy = action.payloadGrafico

      return { ...state, caixa: caixaCopy, totalEntrada: action.payloadEntrada, totalResultado: action.payloadResultado, totalSaida: action.payloadSaida, totalSaldo: action.payloadSaldo, grafico: graficoCopy }
    }
    case 'CAIXA_FLUXO_TRANSACAO_FETCH': {
      const transacoesCopy = []
      let contaspagarArray = []
      const arrayConta = []


      for (const recorrente of action.payload) {

        let i = 0
        const dataOriginal = new Date(recorrente.data)
        const inicio = new Date(action.inicio)
        const fim = new Date(action.fim)

        switch (recorrente.frequencia) {
          case ('DIARIO'):
            while (i < action.dias) {
              const copyRecorrente = { ...recorrente }

              // : new Date(dataOriginal.setDate(dataOriginal.getDate() + 1))
              copyRecorrente['data_vencimento'] = copyRecorrente['data_vencimento'] ?  copyRecorrente['data_vencimento']:  new Date(dataOriginal);
              if ((copyRecorrente['data_vencimento'] >= inicio) && (copyRecorrente['data_vencimento'] <= fim)) {
                arrayConta.push(copyRecorrente)
              } 
              i++
            }
          case ('SEMANAL'):
            while (i < action.semanas) {

              const copyRecorrente = { ...recorrente }


              copyRecorrente['data_vencimento'] = copyRecorrente['data_vencimento'] ?  copyRecorrente['data_vencimento']:  new Date(dataOriginal);

              console.log(copyRecorrente['data_vencimento'], 'copyRecorrente[data_vencimento]')
              console.log(inicio, 'inicio')
              console.log(fim, 'fim')

              if ((copyRecorrente['data_vencimento'] >= inicio) && (copyRecorrente['data_vencimento'] <= fim)) {
                console.log('entrou aqui depois do if')
                arrayConta.push(copyRecorrente)
              }
              i++
            }
            
          case ('MENSAL'):
            while (i < action.meses) {
              const copyRecorrente = { ...recorrente }

              copyRecorrente['data_vencimento'] = copyRecorrente['data_vencimento'] ?  copyRecorrente['data_vencimento']:  new Date(dataOriginal);

              // copyRecorrente['data_vencimento'] = copyRecorrente['data_vencimento'] ? new Date(dataOriginal) : new Date(dataOriginal.setMonth(dataOriginal.getMonth() + 1))
              if ((copyRecorrente['data_vencimento'] >= inicio) && (copyRecorrente['data_vencimento'] <= fim)) {
                arrayConta.push(copyRecorrente)
              }
              i++
            }
          case ('ANUAL'):
            while (i < action.anos) {
              const copyRecorrente = { ...recorrente }

              console.log(copyRecorrente, 'copyRecorrente Anual')

              // copyRecorrente['data_vencimento'] = copyRecorrente['data_vencimento'] ? new Date(dataOriginal) : new Date(dataOriginal.setFullYear(dataOriginal.getFullYear()))
              copyRecorrente['data_vencimento'] = copyRecorrente['data_vencimento'] ?  copyRecorrente['data_vencimento']:  new Date(dataOriginal);

              if ((copyRecorrente['data_vencimento'] >= inicio) && (copyRecorrente['data_vencimento'] <= fim)) {
                arrayConta.push(copyRecorrente)
              }
              i++
            }
          default:
            const copyRecorrente = { ...recorrente }
            arrayConta.push(copyRecorrente)

        }

        transacoesCopy.forEach((transacao, index) => {
          const copyTransacao = { ...transacao }

          copyTransacao['data_vencimento'] = copyTransacao['data']
          transacoesCopy[index] = copyTransacao

        })

        contaspagarArray = [].concat(transacoesCopy, arrayConta)

        contaspagarArray.sort(function (a, b) {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(a.data_vencimento) - new Date(b.data_vencimento)
        })

      }

      console.log(contaspagarArray)

      return { ...state, transacoes: contaspagarArray, totalPagamento: action.totalPagamento, totalRecebimento: action.totalRecebimento, totalResultado: action.totalResultado }
    }
    case 'CAIXA_FLUXO_SET_FILTRO': {
      const dadosFiltroCopy = { ...state.dadosFiltro }

      dadosFiltroCopy[action.campo] = action.valor
      return { ...state, dadosFiltro: dadosFiltroCopy }
    }
    case 'CAIXA_FLUXO_SET_FILTRO_CLEAR': {

      const dadosFiltroCopy = {
        filtroDataDe: new Date(),
        filtroDataAte: new Date(),
        clear: false
      }

      return { ...state, dadosFiltro: dadosFiltroCopy }
    }
    default:
      return state
  }
}